import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import classes from './landingWelcome.module.css';
import leftPic from '../../static/loading/left_pic.png'

const LandingWelcome = props => {

    return (
        <div className={classes.root}>
            <div className={classes.left_top}>
                <h1>
                    <FormattedMessage
                        id="global.systemLandingTitle"
                        defaultMessage={"Welcome back to HadaPass Platform Merchant portal"}
                    />
                </h1>
                <p>
                    <FormattedMessage
                        id="global.systemLandingMessage"
                        defaultMessage={"Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed qu"}
                    />
                </p>
            </div>
            <div className={classes.left_bottom}>
                <img src={leftPic} alt='' />
            </div>
        </div>
    )
}

export default LandingWelcome;